import { Button } from '@material-ui/core'

import withClickTracker from './withClickTracker'

const TrackButton = withClickTracker(Button)

export default TrackButton
